/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PaymentSetupData
 */
export interface PaymentSetupData {
    /**
     * 
     * @type {string}
     * @memberof PaymentSetupData
     */
    setupIntentClientSecret?: string | null;
}

/**
 * Check if a given object implements the PaymentSetupData interface.
 */
export function instanceOfPaymentSetupData(value: object): value is PaymentSetupData {
    return true;
}

export function PaymentSetupDataFromJSON(json: any): PaymentSetupData {
    return PaymentSetupDataFromJSONTyped(json, false);
}

export function PaymentSetupDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentSetupData {
    if (json == null) {
        return json;
    }
    return {
        
        'setupIntentClientSecret': json['setupIntentClientSecret'] == null ? undefined : json['setupIntentClientSecret'],
    };
}

export function PaymentSetupDataToJSON(json: any): PaymentSetupData {
    return PaymentSetupDataToJSONTyped(json, false);
}

export function PaymentSetupDataToJSONTyped(value?: PaymentSetupData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'setupIntentClientSecret': value['setupIntentClientSecret'],
    };
}

